import {createEvent} from "./createEvent";

export type LoggedInPayload = {
    redirect?: string;
};

export type LoggedOutPayload = {
    redirect?: string;
};

export const authEvents = {
    loginRequired: createEvent(), // Действию нужна авторизация, показать форму входа
    getSmsSuccess: createEvent(), // Запрос смс кода (удачная попытка)
    getSmsFailed: createEvent(), // Запрос смс кода (неудачная попытка)
    loginSuccess: createEvent<LoggedInPayload>(), // Вошел в систему
    loginFailed: createEvent(), // Неудачная попытка входа в систему
    logout: createEvent<LoggedOutPayload>(), // Вышел из системы
    sessionExpired: createEvent(), // Сессия истекла
    profileUpdated: createEvent(), // Данные профиля обновлены
};
